<ng-container *ngIf="this.framed; then unframedHeader; else framedHeader">
</ng-container>
<ng-template #unframedHeader>
    <router-outlet></router-outlet>
</ng-template>

<ng-template #framedHeader>
    <div
        class="layout-body"
        [class.layout-body-alt]="!this.authenticateComplete"
    >
        <div
            *ngIf="
                this.authenticateComplete;
                then normalHeader;
                else authHeader
            "
        >
        </div>
        <!-- Public Layout -->
        <ng-template #authHeader>
            <q-layout-public>
                <router-outlet></router-outlet>
            </q-layout-public>
        </ng-template>

        <!-- Secure Layout -->
        <ng-template #normalHeader>
            <q-layout-secure>
                <router-outlet></router-outlet>
            </q-layout-secure>
        </ng-template>
    </div>
</ng-template>

<q-download></q-download>
